import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import apiBarcode from '../../../services/api/apiBarcode'
import ChildrenActionCol from './TableData/ChildrenActionCol'
import DesignBackCol from './TableData/DesignBackCol'
import DesignFrontCol from './TableData/DesignFrontCol'
import DesignSleevesCol from './TableData/DesignSleevesCol'
import LabelShipChildCol from './TableData/LabelShipChildCol'
import MockUpBackCol from './TableData/MockUpBackCol'
import MockUpFrontCol from './TableData/MockUpFrontCol'
import PrintInfoCol from './TableData/PrintInfoCol'
import ProductionCol from './TableData/ProductionCol'
import VariantCol from './TableData/VariantCol'
import {generateLabelShip} from '../../../services/api/apiNextBarcode'
import {pushNewItemHistory} from '../../../services/api/apiItemHistory'
import {Tooltip} from "reactstrap"

class ChildRow extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoadingGenerate: false,
            isLoadingDelete: false,
            isLoadingPrint: false,
            isLoadingShip: false,
            isLoadingDuplicate: false,
            tooltipOpen: false
        }
    }

    _setTooltipOpen = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        })
    }

    _renderIconGenerate = () => {
        return this.state.isLoadingGenerate ? <i className='icon-spinner2 spinner ml-3'/> :
            <i className='icon-barcode2 text-primary' onClick={this._handleClickGenerate}/>
    }

    _handleClickGenerate = async () => {
        try {
            this.setState({
                isLoadingGenerate: true
            })

            const {item, reloadItems} = this.props

            const payload = {
                status: item.gen_at !== undefined ? 'regenerated' : 'generated'
            }

            const {success, message} = await generateLabelShip(item._id, payload)

            if (!success) {
                this.setState({
                    isLoadingGenerate: false
                })

                throw new Error(message)
            }

            this.setState({
                isLoadingGenerate: false
            }, async () => {
                await reloadItems()
            })
        } catch (e) {
            alert(e.message)
        }
    }

    _renderIconDelete = () => {
        if (this.state.isLoadingDelete)
            return <i className='icon-spinner2 spinner ml-3'/>
        return <i className='icon-bin text-danger ml-3' onClick={this._handleClickDelete}/>
    }

    _handleClickDelete = async () => {
        const r = window.prompt('Bạn có chắc chắn muốn XÓA đơn hàng này?\nĐơn hàng đã XÓA sẽ không thể khôi phục lại\nGõ "ok" và bấm OK để xóa')
        // console.log(r)
        if (r !== 'ok') {
            console.log('bạn phải gõ "ok" để xóa đơn hàng')
            return
        }

        this.setState({isLoadingDelete: true})

        try {
            const {item, reloadItems} = this.props

            const resDelete = await apiBarcode.deleteBarcode(item._id)

            const {success, message} = resDelete.data
            if (!success) throw new Error(message)

            await reloadItems()
        } catch (e) {
            alert(e.message)
        }

        this.setState({isLoadingDelete: false})
    }

    _handleClickEdit = () => {
        const {item, openModalEdit} = this.props
        openModalEdit(item)
    }

    _handleClickEditCommitTime = () => {
        const {item, openModalEditCommitTime} = this.props
        openModalEditCommitTime(item)
    }

    _handleClickEditProduct = () => {
        const {item, openModalEditProduct} = this.props
        // console.log(item)
        const {
            _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            designSleeveLeft,
            designSleeveRight,
            size,
            color,
            type,
            quantity,
            production_status,
            productStatus,
            note,
            storename
        } = item
        const product = {
            barcodeId: _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            designSleeveLeft,
            designSleeveRight,
            size,
            color,
            type,
            quantity,
            production_status,
            productStatus,
            note,
            storename
        }

        openModalEditProduct(product)
    }

    _handleMarkFaileDesign = () => {
        const {item, openModalMarkFaileDesign} = this.props
        // console.log(item)
        const {
            _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            size,
            color,
            type,
            quantity,
            production_status,
            productStatus,
            note,
            storename
        } = item
        const product = {
            barcodeId: _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            size,
            color,
            type,
            quantity,
            production_status,
            productStatus,
            note,
            storename
        }

        openModalMarkFaileDesign(product)
    }

    _handleDeleteLabel = async () => {
        const r = window.confirm('Bạn có chắc chắn muốn xóa label này?')
        if (!r) return

        try {
            const {item, reloadItems} = this.props

            const resUpdated = await apiBarcode.updateBarcode(item._id, {labelDetails: null})
            const {success, message} = resUpdated.data
            if (!success) throw new Error(message)

            await reloadItems()

            return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                event_key: 'delete_label',
                event_description: `Delete label`,
                event_meta: {
                    source: 'single_delete_label',
                }
            })
        } catch (e) {
            alert(e.message)
        }

    }

    render() {
        const {tooltipOpen} = this.state
        const {item, itemsRequest, onChangeFilterTag, parentTags, filter, onChangeFilter} = this.props
        const {production_status, tags} = item
        const commitmentTime = item && item.preference && item.preference.commitment_time || item.commitment_time

        const productStatus = item.productStatus || 'error'
        const classNameItem = classNames('d-flex flex-wrap', {
            ListItemsItem: true,
            BorderNone: true,
            'text-success': productStatus === 'completed' && item.status !== 'error',
            disabled: production_status === 'packaged',
            'rowArchived': item.is_archived,
            disabledCancel: production_status === 'cancelled' || production_status === 'on-hold' || productStatus === 'cancelled',
            'bg-dark': item.status === 'error',
            'text-warning': item.status === 'error',
            'hold-ship': parentTags.includes('hold-ship'),
            'false-design': productStatus === 'false_design',
        })

        return (
            <div className={classNameItem} id={"Tooltip-" + item._id + '_' + item.pos}>
                <div className="notDisableCancel bulkActions"/>
                <div className="OrderNumber "/>
                <PrintInfoCol pos={item.pos} total={!!item.products && item.products.length}
                              order3d={Boolean(item.order3d)}
                              order3d_at={item.order3d_at} printed_at={item.printed_at} type={item.type}
                              printed_ip={item.printed_ip} barcode_number={item.barcodeNumber} tags={tags}/>
                <MockUpFrontCol mockUpFront={item.mockUpFront}/>
                <MockUpBackCol mockUpBack={item.mockUpBack}/>
                <DesignFrontCol designFront={item.designFront} productStatus={productStatus}/>
                <DesignBackCol designBack={item.designBack} productStatus={productStatus}/>
                <DesignSleevesCol designSleeves={item.designSleeves} productStatus={productStatus} item={item}/>
                <VariantCol type={item.type} brandName={item.brand_name} color={item.color} size={item.size} filter={filter} onChangeFilter={onChangeFilter}/>
                <div className="Address"/>
                <LabelShipChildCol multiLabel={Boolean(item.multiLabel)} hasLabel={Boolean(item.hasLabel)}
                                   labelDetails={item.labelDetails}/>
                <div className="OrderPhoto"/>
                <div className="Created"/>
                <ProductionCol production_time={item.production_time} commitment_time={commitmentTime}
                               productStatus={productStatus}/>
                <ChildrenActionCol tags={tags} production_status={item.production_status} productStatus={productStatus}
                                   handleClickEditProduct={this._handleClickEditProduct}
                                   handleClickMarkFaileDesign={this._handleMarkFaileDesign}
                                   item={item}
                                   itemsRequest={itemsRequest}
                                   onChangeFilterTag={onChangeFilterTag}
                />
                {
                    item.is_archived && (
                        <Tooltip
                            isOpen={tooltipOpen}
                            target={"Tooltip-" + item._id + '_' + item.pos}
                            toggle={this._setTooltipOpen}
                        >
                            Đã archive
                        </Tooltip>
                    )

                }
            </div>
        )
    }
}

ChildRow.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    reloadItems: PropTypes.func.isRequired,
}

export default ChildRow
